module.exports = __webpack_public_path__ + "img/6_160.60777da0.png";